// AdminSidebar.jsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
//import logo from '../../public/assets/images/logormv.png'; // Make sure you have a logo image in this path

const AdminSidebar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  // Helper function to check if the link is active
  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className={`admin-sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
        <img src="/assets/images/logormv.png" alt="Food Delivery Online" />
          {/* <img src={logo} alt="Food Delivery Online" /> */}
          {!collapsed && <span>Food Delivery</span>}
        </div>
        <button className="collapse-btn" onClick={toggleSidebar}>
          {collapsed ? '→' : '←'}
        </button>
      </div>

      <div className="admin-profile">
        <div className="admin-avatar">
          <img src="/admin-avatar.png" alt="Admin" />
        </div>
        {!collapsed && <h3 className="admin-name">Administrator</h3>}
      </div>

      <nav className="sidebar-nav">
        <ul>
          <li className={isActive('/admin/dashboard') ? 'active' : ''}>
            <Link to="/admin/dashboard">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
              {!collapsed && <span>Dashboard</span>}
            </Link>
          </li>
          <li className={isActive('/admin/users') ? 'active' : ''}>
            <Link to="/admin/users">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              {!collapsed && <span>Manage Users</span>}
            </Link>
          </li>
          <li className={isActive('/admin/restaurants') ? 'active' : ''}>
            <Link to="/admin/restaurants">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 9V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2"></path>
                <rect x="14" y="7" width="8" height="10" rx="2"></rect>
              </svg>
              {!collapsed && <span>Manage Restaurants</span>}
            </Link>
          </li>
          <li className={isActive('/admin/food-items') ? 'active' : ''}>
            <Link to="/admin/food-items">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 12h16M4 6h16M4 18h16"></path>
              </svg>
              {!collapsed && <span>Manage Food Items</span>}
            </Link>
          </li>
          <li className={isActive('/admin/orders') ? 'active' : ''}>
            <Link to="/admin/orders">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
              {!collapsed && <span>Orders</span>}
            </Link>
          </li>
          <li className={isActive('/admin/statistics') ? 'active' : ''}>
            <Link to="/admin/statistics">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="20" x2="18" y2="10"></line>
                <line x1="12" y1="20" x2="12" y2="4"></line>
                <line x1="6" y1="20" x2="6" y2="14"></line>
              </svg>
              {!collapsed && <span>Statistics</span>}
            </Link>
          </li>
          <li className={isActive('/admin/messages') ? 'active' : ''}>
            <Link to="/admin/messages">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
              {!collapsed && <span>Contact Messages</span>}
            </Link>
          </li>
        </ul>
      </nav>

      <div className="sidebar-footer">
        <Link to="/admin/logout" className="logout-btn">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          {!collapsed && <span>Logout</span>}
        </Link>
      </div>

      <style jsx>{`
        .admin-sidebar {
          background: #1a1c2e;
          color: white;
          height: 100vh;
          width: 250px;
          position: fixed;
          left: 0;
          top: 0;
          transition: all 0.3s ease;
          z-index: 999;
          display: flex;
          flex-direction: column;
        }

        .admin-sidebar.collapsed {
          width: 70px;
        }

        .sidebar-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px 15px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .sidebar-logo {
          display: flex;
          align-items: center;
        }

        .sidebar-logo img {
          height: 30px;
          animation: pulse 2s infinite;
        }

        .sidebar-logo span {
          font-size: 1.2rem;
          font-weight: bold;
          margin-left: 10px;
          white-space: nowrap;
        }

        .collapse-btn {
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          font-size: 16px;
          padding: 5px;
          transition: all 0.3s ease;
        }

        .collapse-btn:hover {
          transform: scale(1.1);
        }

        .admin-profile {
          padding: 20px 15px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .admin-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
          border: 2px solid #ff6b6b;
        }

        .admin-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .admin-name {
          margin-left: 10px;
          margin-bottom: 0;
          font-size: 14px;
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .sidebar-nav {
          flex: 1;
          overflow-y: auto;
          padding: 15px 0;
        }

        .sidebar-nav ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .sidebar-nav li {
          margin-bottom: 5px;
        }

        .sidebar-nav li a {
          display: flex;
          align-items: center;
          padding: 12px 15px;
          color: rgba(255, 255, 255, 0.7);
          text-decoration: none;
          transition: all 0.3s ease;
          border-left: 3px solid transparent;
        }

        .sidebar-nav li a:hover {
          background: rgba(255, 255, 255, 0.08);
          color: white;
          border-left-color: #ff6b6b;
        }

        .sidebar-nav li.active a {
          background: rgba(255, 255, 255, 0.1);
          color: white;
          border-left-color: #ff6b6b;
        }

        .sidebar-nav li a svg {
          width: 18px;
          height: 18px;
          margin-right: 15px;
          transition: all 0.3s ease;
        }

        .sidebar-nav li a span {
          opacity: 1;
          transition: opacity 0.3s ease;
          white-space: nowrap;
        }

        .admin-sidebar.collapsed .sidebar-nav li a span {
          opacity: 0;
          width: 0;
        }

        .admin-sidebar.collapsed .sidebar-nav li a svg {
          margin-right: 0;
        }

        .sidebar-footer {
          padding: 15px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }

        .logout-btn {
          display: flex;
          align-items: center;
          color: rgba(255, 255, 255, 0.7);
          text-decoration: none;
          padding: 10px;
          border-radius: 5px;
          transition: all 0.3s ease;
        }

        .logout-btn:hover {
          background: rgba(255, 255, 255, 0.08);
          color: #ff6b6b;
        }

        .logout-btn svg {
          width: 18px;
          height: 18px;
          margin-right: 15px;
        }

        .logout-btn span {
          transition: opacity 0.3s ease;
        }

        .admin-sidebar.collapsed .logout-btn span {
          opacity: 0;
          width: 0;
        }

        .admin-sidebar.collapsed .logout-btn svg {
          margin-right: 0;
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }

        @media (max-width: 768px) {
          .admin-sidebar {
            transform: translateX(-100%);
            box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
          }

          .admin-sidebar.open {
            transform: translateX(0);
          }
        }
      `}</style>
    </div>
  );
};

export default AdminSidebar;